import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { cardAnimations } from 'src/app/utilities/animations';
import { Orientation } from '@ngmodule/material-carousel';
import { SharedServiceService } from 'src/app/services/shared-service.service';
import { QdeService } from 'src/app/services/qde.service';
import { GENERIC_ERROR, base_https_url, ISTATACARD, DOC_UPLOAD_LINK } from 'src/app/config/app-settings.config';
import { LoaderService } from 'src/app/services/loader.service';
import { IwService } from 'src/app/services/iw.service';
import { ThemeService } from 'src/app/services/theme.service';


@Component({
  selector: 'app-card-upgrade-popup',
  templateUrl: './card-upgrade-popup.component.html',
  styleUrls: ['./card-upgrade-popup.component.scss'],
  animations: [cardAnimations],
  encapsulation: ViewEncapsulation.None
})
export class CardUpgradePopupComponent implements OnInit {
  slidesList: any;
  color: any;
  slides: any;
  public timings = '125ms ease-in';
  public autoplay = false;
  public interval = 5000;
  public loop = true;
  public hideArrows = false;
  public hideIndicators = false;
  public maxWidth = 'auto';
  public proportion = 110;
  public useKeyboard = true;
  public useMouseWheel = false;
  public orientation: Orientation = 'ltr';
  displayOffer: any[];
  orignalCardJson: any;
  isBanca: boolean;
  upgradeBody: any;
  appNumber: any;
  sbic_card: any;
  finalCardJson: any;
  errorMessage: any;
  base_url = base_https_url;
  cardExisting: any;
  eapplyFormLabel: any;
  convertedjsonLi: any;
  partnerCode: any = sessionStorage.getItem('partner-code');
  containerType: any = sessionStorage.getItem('container-type');

  constructor(public dialog: MatDialog,
    private router: Router,
    private sharedService: SharedServiceService,
    private qdeService: QdeService,
    private loaderService: LoaderService,
    private iw: IwService,
    private themeService: ThemeService
  ) { 
    this.partnerCode = this.themeService.partnerCode;
  }

  ngOnInit() {
    this.displayOffer = this.sharedService.offerlist;
    this.cardExisting = this.sharedService.initialCardJson;
    if (this.sharedService.trackApplicationResponse) {
      this.appNumber = this.sharedService.trackApplicationResponse.applicationNumber ? this.sharedService.trackApplicationResponse.applicationNumber : '';
    } else {
      this.appNumber = this.qdeService.qdeSubmitData && this.qdeService.qdeSubmitData.applicationNumber ? this.qdeService.qdeSubmitData.applicationNumber : '';
    }
    this.orignalCardJson = JSON.parse(localStorage.getItem("convertedJson"));
    this.eapplyFormLabel = this.iw.geteapplyFormLabelDcr().dcrContent.root;
    const xml = this.orignalCardJson;

    if (xml && xml.root && xml.root['eapply-benefits1'] && xml.root['eapply-benefits1'].benefits && xml.root['eapply-benefits1'].benefits.benefits_desc ) {
       this.convertedjsonLi = '' + xml.root['eapply-benefits1'].benefits.benefits_desc
     }
  }

  createHiddenForm() {
    var form = document.createElement("form");
    form.method = "POST";
    form.action = DOC_UPLOAD_LINK;
    document.body.appendChild(form);
    form.submit();
  }

  selectedCard(offer: any) {
    let city: any;
    let actualPromoCode: any;
    this.orignalCardJson = offer;
    offer.root.card_information.card_type;
    this.sharedService.cardName = offer.root.card_information.card_name;
    if(window['digitalData']){
      window['digitalData'].card ={ cardName : this.sharedService.cardName }
    }
    sessionStorage.setItem('cardName', this.sharedService.cardName);
    if (this.sharedService.trackApplicationResponse) {
      city = this.sharedService.trackApplicationResponse.eapplyContactDetails && this.sharedService.trackApplicationResponse.eapplyContactDetails.resiCity;
    } else {
      city = this.qdeService.aboutData.WSCallUserCity;
    }

    let masterReq = {
      cardType: offer.root.card_information.card_type,
      cardChannelCode: this.isBanca ? 'EALB' : ((this.sharedService.paramschannel && this.sharedService.paramschannel == '701') ? "EABP" : this.sharedService.fromSwiftJourney ? "SAPL" : "EAPL"),
      cityList: 'N',
      companyList: 'N',
      bancaCityList: 'N',
      designationList: 'N',
      userCity: city || '',
      feeAndOfferDetails: 'Y',
    }
    this.upgradeBody = {
      "actualPromo": actualPromoCode,
      "actualCardType": offer.root.card_information.card_type,
      "applicationNumber": this.appNumber ? this.appNumber : ''
    };

    this.loaderService.show()
    this.qdeService.fetchMatserData(masterReq).subscribe((res: any) => {
      if (res.eapplyMasterDataRsType && res.eapplyMasterDataRsType.statusCode && res.eapplyMasterDataRsType.statusCode === "000") {
        this.errorMessage = '';
        this.upgradeBody.actualPromo = res.eapplyMasterDataRsType.wcpParameters.promoCode;
        this.sharedService.feeCodeForDataCapture = res.eapplyMasterDataRsType.feeAndOfferDetails && res.eapplyMasterDataRsType.feeAndOfferDetails.feeCode ? res.eapplyMasterDataRsType.feeAndOfferDetails.feeCode : '';
        this.loaderService.hide()
        this.qdeService.cardUpsellDownsellFromOffer(this.upgradeBody).subscribe((response: any) => {
          const res = { ...response.body };
          if (res) {
            if (res.UpsellDownsellErrorRsType && res.UpsellDownsellErrorRsType.status && res.UpsellDownsellErrorRsType.status.toLowerCase() == "failure") {
              this.errorMessage = GENERIC_ERROR;
            }
            else if (res.UpsellDownsellRsType && res.UpsellDownsellRsType.status && res.UpsellDownsellRsType.status.toLowerCase() == "success") {
              let accessToken: any;
              let expiryTime: any;
              if (response.headers && response.headers.get("access_token")) {
                accessToken = response.headers.get("access_token");
              }
              if (response.headers && response.headers.get("expiry_time")) {
                expiryTime = response.headers.get("expiry_time");
              }

              if (accessToken) {
                sessionStorage.setItem("s24_access_token", accessToken);
              }
              if (expiryTime) {
                sessionStorage.setItem("s24_expiry_time", expiryTime);
              }
              this.sbic_card = offer.root.card_information.card_name;
              this.sharedService.sbic_card_Type = offer.root.card_information.card_type
              this.finalCardJson = offer;
              this.errorMessage = '';
              if (this.sharedService.navigateToCompleteApp) {
                this.router.navigate(['/', 'complete-application']);
                this.dialog.closeAll();
              } else if (this.sharedService.navigateToDocUpload) {
                this.sharedService.appCompleted = true;
                if (this.sharedService.trackApplicationResponse.enableDocumentListFlag) {
                  this.sharedService.appCompleted = true;
                  sessionStorage.setItem('appNo', this.sharedService.trackApplicationResponse.applicationNumber);
                  sessionStorage.setItem('eapplyFlag', 'true');
                  let requestApp = {
                    "applicationNumber": this.sharedService.trackApplicationResponse.applicationNumber
                  }
                  this.sharedService.getExpandUrlForDocUplod(requestApp).subscribe((response: any) => {
                    console.log("fetch params from cardupgrade popup component 165");
                    const res = { ...response.body };
                    if (res && res.FetchDocUploadParamsRsType && res.FetchDocUploadParamsRsType.status) {
                      if (res.FetchDocUploadParamsRsType.status) {
                        let accessToken: any;
                        let expiryTime: any;
                        if (response.headers && response.headers.get("access_token")) {
                          accessToken = response.headers.get("access_token");
                        }
                        if (response.headers && response.headers.get("expiry_time")) {
                          expiryTime = response.headers.get("expiry_time");
                        }

                        if (accessToken) {
                          sessionStorage.setItem("s24_access_token", accessToken);
                        }
                        if (expiryTime) {
                          sessionStorage.setItem("s24_expiry_time", expiryTime);
                        }
                        sessionStorage.setItem('eAppId', res.FetchDocUploadParamsRsType.applicationId);
                        sessionStorage.setItem('eVerificationCode', res.FetchDocUploadParamsRsType.verificationCode);
                        this.createHiddenForm();
                      }
                    } else {
                      this.createHiddenForm();
                    }
                  }, err => {
                    this.createHiddenForm();
                  })
                }
              } else if (this.sharedService.navigateToScheduleAppointment) {
                this.router.navigate(['/', 'schedule-appointment']);
                this.dialog.closeAll();
              } else if ((this.sharedService.navigateToAddon) || (this.sharedService.navigateToCrossSell)) {
                this.router.navigate(['/', 'addon-card']);
                this.dialog.closeAll();
              } else {
                this.router.navigate(['/', 'success']);
                this.dialog.closeAll();
              }
            }
          }
        }, err => {
          this.errorMessage = GENERIC_ERROR;
        });
      } else {
        this.errorMessage = GENERIC_ERROR;
        this.loaderService.hide()

      }
    }, err => {
      this.errorMessage = GENERIC_ERROR;
      this.loaderService.hide()

    });
  }
}
